module.exports = __webpack_public_path__ + "img/43299.89358dfb.jpg";